module.exports = __webpack_public_path__ + "static/wikinav-1c1b1cd190b2147af7c8ac1f5324a329.png";